import Shop from './pages/Landing/store.js'

const miniMeat = {
  // ミニマウルタッシェンミート
  key: 'mini-meat',
  uuid: 'eeda68fd-5f32-400b-b1e5-cbdc86dbebfa',
  de: 'Mini Maultaschen Meat',
  catchphrase: 'パスタ生地で豚肉とほうれん草を包んだ\n小さなマウルタッシェン！',
  series: 'ミニマウルタッシェン',
  name: 'ミニマウルタッシェン\nミート',
  ingredients: 'セモリナ粉、豚肉、パン粉、ほうれん草、玉ねぎ、パセリ',
  allergen: '小麦 豚肉 卵',
  commentAlt: 'ひとくちサイズで色々使える！',
  quantity: '1kg（1個約11g・約90個入）',
  price: 1450,
  num: null,
  sort_order: 1,
  category: 'singleItem',
  deliveryFeeFree: false
}

const miniCheese = {
  // ミニマウルタッシェンチーズ
  key: 'mini-cheese',
  uuid: 'd3f3f507-75ee-4223-bc50-eea1687eaaa6',
  de: 'Mini Maultaschen Cheese',
  catchphrase: 'パスタ生地に二種類のチーズを詰めました。\nスナックやお菓子としても！',
  series: 'ミニマウルタッシェン',
  name: 'ミニマウルタッシェン\nチーズ',
  ingredients: 'セモリナ粉、ナチュラルチーズ（クワルク、エメンタールチーズ）、卵',
  allergen: '小麦 乳 卵',
  commentAlt: 'ひとくちサイズで色々使える！',
  quantity: '1kg（1個約11g・約90個入）',
  price: 1600,
  num: null,
  sort_order: 2,
  category: 'singleItem',
  deliveryFeeFree: false
}

const schupfnudeln = {
  // フィンガーポテト
  key: 'schupfnudeln',
  uuid: 'd746d3ad-dd13-4c36-aef4-dac784d5ca71',
  de: 'Schupfnudeln',
  catchphrase: 'もちもち食感のドイツ風じゃがいもパスタ。\n色々な料理に使えます！',
  series: 'フィンガーポテト',
  name: 'フィンガーポテト',
  ingredients: 'ジャガイモ、小麦粉、卵、食塩',
  allergen: '小麦 卵',
  commentAlt: 'くせになるもちもち食感ポテト',
  quantity: '1kg（1個約10g・約100本入）',
  price: 1350,
  num: null,
  sort_order: 3,
  category: 'singleItem',
  deliveryFeeFree: false
}

const spaetzle = {
  // シュペッツレ
  key: 'spaetzle',
  uuid: '4fe1c2c0-f7b1-4a69-8be8-69c372928cb2',
  de: 'Eierspätzle',
  catchphrase: '欧州で愛されている卵入りショートパスタ。\n独特の形状でソースが絡みやすい！',
  series: 'シュペッツレ',
  name: 'シュペッツレ',
  ingredients: 'セモリナ粉、豚肉、パン粉、ほうれん草、玉ねぎ、パセリ',
  allergen: '小麦 卵',
  commentAlt: 'なぜか懐かしい素朴な味',
  quantity: '1kg',
  price: 1450,
  num: null,
  sort_order: 4,
  category: 'singleItem',
  deliveryFeeFree: false
}

const setOkigaru = {
  // お気軽セット
  key: 'set_okigaru',
  uuid: '514f76d4-3435-4f73-a892-fa76d0615f95',
  catchphrase: '初めての方におすすめ！',
  name: 'お気軽セット',
  text: 'ミニマウルタッシェンミートとチーズのセット。',
  quantity: 'ミニマウルタッシェンミート１袋（1kg）\nミニマウルタッシェンチーズ１袋（1kg）',
  price: 2500,
  off: '550円',
  num: null,
  sort_order: 5,
  category: 'specials',
  deliveryFeeFree: true
}

const setYoridori = {
  // よりどりお得セット
  key: 'set_yoridori',
  uuid: '9a7ba920-9ea9-4709-abaa-9ba449a241a5',
  catchphrase: 'お好きな商品が選べる!',
  name: 'よりどりお得セット',
  text: '好きな商品が選べて、更にお得なわがままセット!',
  quantity: 'ミニマウルタッシェンチーズ\nミニマウルタッシェンミート\nフィンガーポテト\nシュペッツレ\n各１パック（1kg）の中から３種類',
  price: 3900,
  off: '最大1,250円',
  num: null,
  select: [{
    'value': 1,
    'text': 'ミニマウルタッシェンミート'
  }, {
    'value': 2,
    'text': 'ミニマウルタッシェンチーズ'
  }, {
    'value': 3,
    'text': 'フィンガーポテト'
  }, {
    'value': 4,
    'text': 'シュペッツレ'
  }],
  sort_order: 7,
  category: 'selects',
  deliveryFeeFree: true
}
export default {
  namespaced: true,
  modules: {
    shop: Shop
  },
  state () {
    return {
      items: [
        miniMeat,
        miniCheese,
        schupfnudeln,
        spaetzle,
        setOkigaru,
        setYoridori
      ]
    }
  },
  getters: {
    items (state) {
      return state.items
    }
  },
  mutations: {},
  actions: {}
}



// WEBPACK FOOTER //
// ./src/app/store.js